<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useDarkMode } from '@/composables/useDarkMode'
import ToastContainer from '@/components/ui/ToastContainer.vue'
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
import ErrorBoundary from '@/components/ui/ErrorBoundary.vue'

// Initialize dark mode from localStorage/system preference
useDarkMode()
</script>

<template>
  <ErrorBoundary>
    <RouterView />
  </ErrorBoundary>
  <ToastContainer />
  <ConfirmDialog />
</template>
